<template>
  <v-card elevation="1">
    <v-card-title>{{ text.pages.cart.cartTitle }}</v-card-title>
    <v-card-subtitle>{{ text.pages.cart.cartSubtitle }}:
      {{ totalPriceToPay.toFixed(2) }}{{ text.common.currency }}
    </v-card-subtitle>
    <v-card-text :class="{
      'pa-0': $vuetify.breakpoint.mobile
    }">
      <v-stepper
        v-model="currentStep"
        vertical
      >
        <v-stepper-step
          :complete="currentStep > 1"
          step="1"
          :class="{'pl-1': $vuetify.breakpoint.mobile}"
        >
          {{ text.pages.cart.steps[1] }}
        </v-stepper-step>
        <v-stepper-content step="1"
                           :class="{
          'pl-1 pr-8 ml-4': $vuetify.breakpoint.mobile
        }">
          <CartTable v-on:confirm="currentStep += 1"
                     :currentStep="currentStep"
                     v-on:back="currentStep -= 1"
          />
        </v-stepper-content>

        <v-stepper-step
          :complete="currentStep > 2"
          step="2"
          :class="{'pl-1': $vuetify.breakpoint.mobile}"
        >
          {{ text.pages.cart.steps[2] }}
        </v-stepper-step>
        <v-stepper-content step="2" :class="{'pl-1 pr-8 ml-4': $vuetify.breakpoint.mobile}">
          <CartDelivery v-if="currentStep > 1"
                        v-on:confirm="currentStep += 1"
                        v-on:back="currentStep -= 1"
                        :currentStep="currentStep"
                        v-on:setDeliveryPrice="setDeliveryPrice"
          />
        </v-stepper-content>

        <v-stepper-step
          :complete="currentStep > 3"
          step="3"
          :class="{'pl-1': $vuetify.breakpoint.mobile}"
        >
          {{ text.pages.cart.steps[3] }}
        </v-stepper-step>

        <v-stepper-content step="3" :class="{'pl-1 pr-8 ml-4': $vuetify.breakpoint.mobile}">
          <CartAddress v-if="currentStep > 2"
                       v-on:confirm="currentStep += 1"
                       v-on:back="currentStep -= 1"
                       :currentStep="currentStep"
          />
        </v-stepper-content>

        <v-stepper-step step="4" :complete="currentStep > 4"
                        :class="{'pl-1': $vuetify.breakpoint.mobile}">
          {{ text.pages.cart.steps[4] }}
        </v-stepper-step>
        <v-stepper-content step="4" :class="{'pl-1 pr-8 ml-4': $vuetify.breakpoint.mobile}">
          <CartPayment v-if="currentStep > 3"
                       v-on:confirm="currentStep += 1"
                       v-on:back="currentStep -= 1"
                       :currentStep="currentStep"
          />
        </v-stepper-content>

        <v-stepper-step step="5" :complete="currentStep > 3"
                        :class="{'pl-1': $vuetify.breakpoint.mobile}">
          {{ text.pages.cart.steps[5] }}
        </v-stepper-step>
        <v-stepper-content step="5" :class="{'pl-1 pr-8 ml-4': $vuetify.breakpoint.mobile}">
          <v-row v-if="currentStep === 5" justify="end">
            <v-col cols="2" class="text-right">
              <v-btn color="primary" @click="currentStep -= 1" large>
                <v-icon>mdi-arrow-left-bold</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="currentStep === 5" justify="center">
            <v-col cols="12" md="5">
              <v-btn color="primary" x-large @click="buy" :disabled="disabledPayButton">
                {{ text.pages.cart.orderAndPay }}: {{ totalPriceToPay.toFixed(2) }}
                {{ text.common.currency }}
              </v-btn>
            </v-col>
            <v-col cols="12" v-if="isOnlineTransacionPayment">
              <v-row justify="center">
                <v-col cols="1" class="pt-0">
                  <v-checkbox class="mt-2"
                              @click="acceptPrzelewy24Rules"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="7" class="text-center"
                       v-html="text.pages.cart.przelewy24Rules"/>
              </v-row>
            </v-col>
          </v-row>
        </v-stepper-content>

        <v-stepper-step step="6" :complete="currentStep > 6"
                        :class="{'pl-1': $vuetify.breakpoint.mobile}">
          {{ text.pages.cart.steps[6] }}
        </v-stepper-step>
        <v-stepper-content step="6" :class="{'pl-1 pr-8 ml-4': $vuetify.breakpoint.mobile}">
          <CartPayment v-if="currentStep > 6"
                       v-on:confirm="currentStep += 1"
                       v-on:back="currentStep -= 1"
                       :currentStep="currentStep"
          />
        </v-stepper-content>
      </v-stepper>

    </v-card-text>
  </v-card
  >
</template>

<script>
/* eslint-disable */

import Basket from '@/core/Basket';
import {translations} from '@/lang/translations';
import Axios from '@/core/Axios';
import CartDelivery from '@/components/Pages/CartDelivery.vue';
import CartAddress from '@/components/Pages/CartAddress.vue';
import CartPayment from '@/components/Pages/CartPayment.vue';
import axios from 'axios';
import CartTable from './CartTable.vue';
import {state} from '../../store/index';


export default {
  name: 'CartView',
  components: {
    CartPayment,
    CartDelivery,
    CartTable,
    CartAddress,
  },
  data() {
    return {
      text: translations.pl,
      currentStep: 1,
      deliveryPrice: 0,
      deliveryType: null,
      axios: new Axios(),
      basket: new Basket(),
      transactionRegisterUrl: 'transaction/register',
      transactionBackUrl: 'http://localhost:8080/transaction',
      transactionStatusUrl: 'http://localhost:8080/transaction/status',
    };
  },
  mounted() {
    if (this.basketQuantity === 0) {
      this.$router.push('/');
    }
  },
  computed: {
    basketQuantity() {
      return this.$store.state.basketQuantity;
    },
    totalPriceToPay() {
      return state.basketTotalPrice + this.deliveryPrice;
    },
    disabledPayButton() {
      return !((this.$store.state.orderData.payment === 1
        && this.$store.state.orderData.acceptedRulePrzelewy24 === true)
        || this.$store.state.orderData.payment !== 1);

    },
    isOnlineTransacionPayment() {
      return this.$store.state.orderData.payment === 1;
    },
  },
  watch: {
    basketQuantity(newValue) {
      if (newValue === 0) {
        this.$router.push('/');
      }
    },
  },
  methods: {
    acceptPrzelewy24Rules() {
      this.$store.commit('updateOrderData',
        {acceptedRulePrzelewy24: !this.$store.state.orderData.acceptedRulePrzelewy24});
    },
    buy() {
      const orderData = {
        orderData: JSON.stringify(this.$store.state.orderData),
        uid: this.$store.state.user ? this.$store.state.user.uid : null,
      };
      this.axios.makeCall('POST', 'norbit/order/putorder', orderData)
        .then((response) => {
          if (response.success) {
            const orderNumber = response.transaction.sessionId;
            if (this.isOnlineTransacionPayment) {
              axios.post(process.env.VUE_APP_PRZELEWY24_URL + 'api/v1/transaction/register',
                response.transaction, {
                  auth: {
                    username: process.env.VUE_APP_PRZELEWY24_CLIENT_ID,
                    password: process.env.VUE_APP_PRZELEWY24_API_KEY
                  }
                })
                .then(response => {
                  const transactionData = {
                    orderNumber: orderNumber,
                    token: response.data.data.token,
                    responseCode: response.data.responseCode
                  };
                  this.axios.makeCall('POST',
                    'norbit/order/transactionhistory',
                    transactionData)
                    .then(reponse =>
                      window.location.replace(process.env.VUE_APP_PRZELEWY24_URL +  'trnRequest/' + transactionData.token))
                    .catch(error => {
                      this.$store.dispatch('showSnackBar', {
                        type: 'error',
                        message:
                        this.text.messages.basketError,
                      });
                    });

                })
                .catch(error => {
                  this.$store.dispatch('showSnackBar', {
                    type: 'error',
                    message:
                    this.text.messages.basketError,
                  });
                });
            }
            this.$store.dispatch('showSnackBar', {
              type: 'success',
              message:
              this.text.messages.basketSuccess,
            });
            this.currentStep += 1;
            this.basket.clearBasket();
          }
        })
        .catch(() => {
          this.$store.dispatch('showSnackBar', {
            type: 'error',
            message:
            this.text.messages.basketError,
          });
        });
    },
    setDeliveryPrice(value) {
      this.deliveryPrice = value.price_gross;
      this.deliveryType = value;
    },
  },
};
</script>

<style scoped>
</style>
